import React from "react";
import { FormattedMessage } from "react-intl";

import EmptyData from "../EmptyData";
import ObjectiveCard from "../StrategyMap/ObjectivesCards/ObjectiveCard";

import "./style.scss";

function ObjectivesList({
  items,
  statuses,
  projectStatuses,
  selectedSectors = [],
}) {
  let data = [...items];

  if (selectedSectors.length) {
    const sectorsIDs = selectedSectors.map((sector) => sector.ID);

    data = data?.filter((o) =>
      o?.SectorIDs?.some((element) => sectorsIDs?.includes(element))
    );
  }

  if (!data?.length > 0)
    return <EmptyData title={<FormattedMessage id="no-data" />} />;

  return (
    <div className="objective-list-content">
      {data?.map((e, index) => (
        <ObjectiveCard
          data={e}
          statuses={statuses}
          projectStatuses={projectStatuses}
          width="100%"
          key={e.ID}
        />
      ))}
    </div>
  );
}

export default ObjectivesList;
